// @flow

import * as React from "react"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import ClassNames from "classnames"

import {setPlanning} from "../../actions/planning"
import PlanningList from "../../components/planning-list"
import Config from "../../config"
import type {State as ReduxState, PlanningState, Dispatch} from "../../types"

type Props = {
  dispatch: Dispatch,
  planning: PlanningState,
  t: any,
}

type State = {}

class PlanningViewDashboardView extends React.Component<Props, State> {
  state = {}

  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    // for dashboard views, the base entities are already output in the html
    this.props.dispatch(setPlanning(Config.data.planningItems))
  }

  render() {
    const {planning} = this.props
    const classNames = ClassNames(
      "dashboard-view planning-dashboard container mt-4"
    )

    return (
      <div className={classNames}>
        <div className="row">
          <div className="col-lg-10 col-xl-6">
            <PlanningList
              planningItems={planning.entities}
              showMadam={true}
              readOnly={true}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  planning: state.planning,
})

export default withTranslation()(
  connect(mapStateToProps)(PlanningViewDashboardView)
)
